import { useState } from "react";
import { useTranslation } from "react-i18next";

import { StoppageDto } from "../../../DTOs/Stoppage/StoppageDto";
import { ExpandableTextarea } from "../../../components/ExpandableTextarea/ExpandableTextarea";
import { useIsReadOnly } from "../../../utilities/helpers/roleUtilities";

type WhoWorkedOnItCellProps = {
  stoppage: StoppageDto
  handleWhoWorkedOnItChange: (stoppage: StoppageDto) => Promise<void>
}

const WhoWorkedOnItCell: React.FC<WhoWorkedOnItCellProps> = ({ stoppage, handleWhoWorkedOnItChange }) => {
  const { t } = useTranslation("stoppages");
  const isReadOnly = useIsReadOnly();
  const [textState, setTextState] = useState<string>(stoppage.whoWorkedOnIt || '');

  return (
    <div className="w-full">
      <ExpandableTextarea
        disabled={isReadOnly}
        value={textState}
        placeholder={t("cells.notSpecified")}
        onChange={(e) => setTextState(e.target.value)}
        onSubmit={async () => {
          await handleWhoWorkedOnItChange(new StoppageDto({ ...stoppage, whoWorkedOnIt: textState }));
        }}
      />
    </div>
  )
}

export default WhoWorkedOnItCell